import type { ICashbackLandingPageResources } from "./CashbackLandingPage.Resources";

export const CashbackLandingPageResourcesEn: ICashbackLandingPageResources = {
    whatIsCashback: {
        title: "What is <b>cashback</b>",
        subTitle:
            "When you shop in online stores, <b>you can get some money back</b> - that's cashback. In goodie you will find almost 600 well-known online stores where you can get cashback.",
        step1Title: "Open goodie",
        step1Description: "Register in goodie cashback on goodie.pl or in goodie mobile app.",
        step2Title: "Select store and shop",
        step2Description:
            "Select store in goodie and press 'Go to the shop' button. Choose products and make payment - the same way you always do!",
        step3Title: "Get cashback",
        step3Description:
            "You will find cashback amount on your goodie user account. After transaction is confirmed by the store, your cashback will be accepted.",
        step4Title: "Receive cash to your bank account",
        step4Description:
            "After collecting at least 21 zł of cashback you can transfer it to your account in any bank.",
        videoTitle: "Watch the video",
    },
    faqCashback: {
        title: "Cashback - frequently <b>asked questions</b>",
        question1: "What is Cashback about?",
    },

    categoryList: {
        nameAll: "All",
        namePopular: "Popular",
        nameTechnology: "Electronics",
        nameHealthBeauty: "Health & Beauty",
        nameSportingGoods: "Sporting Goods",
        nameServices: "Services",
        nameHome: "Home",
        nameBaby: "Baby",
        nameManFashion: "Man's fashion",
        nameWomanFashion: "Woman's Fashion",
        nameGrocery: "Grocery",
        nameTravel: "Travel",
        nameAutomotive: "Automotive",
        nameRestaurants: "Restaurants",
        nameEntertainment: "Entertainment",
        namePets: "Pets",
        nameInsurance: "Insurance",
        nameMarketplace: "Marketplace",
    },

    popularCashbackBrands: {
        title: "Popular <b>cashback stores</b>",
        subTitle: "Find your favourite online store and <b>shop cheaper.</b>",
    },

    discountsSection: {
        title: "You <b>can combine</b> cashback with promotions in stores",
    },

    goodieAdvantages: {
        title: "<b>Advantages</b> of goodie cashback",
    },

    mediaAboutUs: {
        title: "<b>Media about us</b>",
    },

    faqCashbackButton: "Show more",

    topSection: {
        registerText: "Register",
        anchorText: "See more",
        title: "Cashback - <b>money refunds for shopping</b>",
        subTitle: "Shop at your favorite online stores and get part of money you spent back.",
    },

    secondRegistrationBanner: {
        title: "If <b>you can only gain</b>, can it hurt to try?",
        registerBtnText: "I want to try",
    },
};
